export default "\n\n\n<ngx-ui-loader></ngx-ui-loader>\n<router-outlet></router-outlet>";